<template lang="pug">
CourseMetadataEditor(:key="fileName" v-bind="courseAndFirm")
</template>

<script setup lang="ts">
import CourseMetadataEditor from './CourseMetadataEditor.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const fileName = computed(() => useRoute().params.fileName as string);

const courseAndFirm = computed(() => {
  const parts = fileName.value.split('_');
  const courseId = Number(parts[parts.length - 1]);
  const firmCode = parts.length > 1 ? parts.slice(0, -1).join('_') : undefined;

  return { courseId, firmCode };
});
</script>
